import {
  CUSTOM_PROMPT_COMPILE_TEMPLATE,
  buildDefaultCustomPromptSteps,
} from '@/constants/visualPrompts/customPromptDefaults';
import type {
  VisualPromptCategory,
  VisualPromptDefinition,
} from '@/types/visualPrompts/visualPrompt.types';

export interface CreateCustomPromptInput {
  title: string;
  description: string;
  category: VisualPromptCategory;
}

export const buildCustomVisualPromptDefinition = (
  input: CreateCustomPromptInput,
): VisualPromptDefinition => {
  const slug = input.title
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .slice(0, 40);

  return {
    id: `custom-${slug}-${Date.now()}`,
    title: input.title.trim(),
    description: input.description.trim(),
    category: input.category,
    promptType: 'instruction',
    version: 1,
    isCustom: true,
    isFeatured: false,
    compileTemplate: CUSTOM_PROMPT_COMPILE_TEMPLATE,
    steps: buildDefaultCustomPromptSteps(),
  };
};
